import { render, staticRenderFns } from "./Method.vue?vue&type=template&id=362c53f8&lang=pug&"
import script from "./Method.vue?vue&type=script&lang=ts&"
export * from "./Method.vue?vue&type=script&lang=ts&"
import style0 from "./Method.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports